import React from 'react';
import PropTypes from 'prop-types';
import IconTimes from '@spothero/icons/times';
import Button from '@spothero/ui/button';

const MonthlySupportMessage = ({
    monthlyPhoneNumber,
    monthlyPhoneNumberFriendly,
    onCloseMonthlySupportMessage,
}) => {
    return (
        <div className="MonthlySupportMessage">
            <small>
                Have questions about monthly parking options? We love to help!{' '}
                <span>
                    Give us a call at{' '}
                    <a href={`tel:${monthlyPhoneNumber}`}>
                        {monthlyPhoneNumberFriendly}
                    </a>
                </span>
            </small>
            <Button
                className="MonthlySupportMessage-close"
                onClick={onCloseMonthlySupportMessage}
            >
                <IconTimes />
            </Button>
        </div>
    );
};

MonthlySupportMessage.propTypes = {
    monthlyPhoneNumber: PropTypes.string.isRequired,
    monthlyPhoneNumberFriendly: PropTypes.string.isRequired,
    onCloseMonthlySupportMessage: PropTypes.func.isRequired,
};

export default MonthlySupportMessage;
